import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ScwMatButtonModule } from 'src/app/shared/component/scw-mat-ui/scw-mat-button/scw-mat-button.module';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { standardModalOptions } from '../base-modal/base-modal.helper';
import { EAnnouncementType, IAnnouncement } from 'src/app/shared/model/announcement/announcement.model';

interface IAnnouncementView {
  message: string;
  iconClass: string;
}

const ICON_CLASS_BY_TYPE: Record<EAnnouncementType, string> = {
  [EAnnouncementType.ALERT]: 'fas fa-exclamation-circle text-danger',
  [EAnnouncementType.WARNING]: 'fas fa-exclamation-triangle text-warning',
  [EAnnouncementType.INFO]: 'fas fa-info-circle text-info',
};

@Component({
  imports: [CommonModule, BaseModalComponent, ScwMatButtonModule, TranslateModule],
  selector: 'app-announcements-modal',
  templateUrl: './announcements-modal.component.html',
})
export class AnnouncementsModalComponent implements OnInit, OnDestroy {
  public static readonly options: NgbModalOptions = standardModalOptions();

  @Input() announcements: IAnnouncement[] = [];
  @Input() modal: NgbActiveModal | undefined;

  public announcementViews: IAnnouncementView[] = [];

  private autoCloseTimeout: ReturnType<typeof setTimeout> | undefined;

  public ngOnInit(): void {
    this.announcementViews = this.announcements.map((announcement: IAnnouncement) => ({
      message: announcement.message,
      iconClass: ICON_CLASS_BY_TYPE[announcement.type] ?? ICON_CLASS_BY_TYPE[EAnnouncementType.INFO],
    }));

    const hasPersistentAnnouncement: boolean = this.announcements.some(
      (announcement: IAnnouncement) => announcement.durationSeconds === null,
    );

    if (!this.announcements.length || hasPersistentAnnouncement) {
      return;
    }

    const maxDurationSeconds: number = Math.max(
      ...this.announcements.map((announcement: IAnnouncement) => announcement.durationSeconds),
    );

    this.autoCloseTimeout = setTimeout(() => this.close(), maxDurationSeconds * 1000);
  }

  public ngOnDestroy(): void {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
    }
  }

  public close(): void {
    this.modal?.close();
  }
}
